module.exports = __webpack_public_path__ + "img/coffee.6aec342f.svg";